import axios from 'axios';
import * as aux from '../../../auxilaries';
import { currentHttpOptions } from '../../../utils';

/**
 * @typedef {typeof import('../../../Enums/TimePeriodRatioOption').TimePeriodRatioOption} ITimePeriodRatioOption
 * @typedef {typeof import('../../../Enums/RequestType').RequestTypes} IRequestTypes
 * @typedef {IRequestTypes[keyof IRequestTypes]} IRequestType
 * 
 * @typedef {{
 *  startDate: Date;
 *  endDate: Date;
 *  requestTypes: IRequestType[];
 * }} BodyAllEmployeeOffersRequest
 * 
 */

/**
 * @brief [BIND (this) when call this function]
 * @param {axios} promise axios call to backend
 * @param {string} success the success message snackbar will load
 *
 */
export function loadAndHandle(promise, success, callback = () => { }) {
    this.props.updateLoading(true);
    promise.then((response) => {
        let message = aux.handleAPIErrors(response)
        if (message) {
            this.handleSnackbar('error', message, true)
            this.props.updateLoading(false);
        }
        else if (success) {
            this.handleSnackbar('success', success, true)
            callback.bind(this)();//All callbacks must set updateLoading(false)
        }
        if (typeof (this.props.closeSidePanel) === 'function')
            this.props.closeSidePanel()
    }).catch((err) => {
        let message = aux.handleAPIErrors(err.response)
        this.handleSnackbar('error', message, true)
        this.props.updateLoading(false);
    });
}

// Dashboard
export const getManagerSettings = (startDate, endDate, options) => {
    const url = process.env.REACT_APP_API_DOTNET + '/api/v1/employee/dashboard/getManagerSettings' +
        `?startDate=${startDate}&endDate=${endDate}`

    return axios.get(url, options);
}

// Dashboard
export const getArchivedManagerSettings = (startDate, endDate, options, managerSettingIds = null) => {
    let url = process.env.REACT_APP_API_DOTNET + '/api/v1/employee/dashboard/GetArchivedManagerSettings' +
        `?startDate=${startDate}&endDate=${endDate}`;

    if (managerSettingIds && managerSettingIds.length > 0) {
        const idsParam = managerSettingIds.map(id => `managerSettingIds=${id}`).join('&');
        url += `&${idsParam}`;
    }

    return axios.get(url, options);
}

export const getPaycodes = (options, startDate, endDate) => {
    return axios.get(process.env.REACT_APP_API_DOTNET + '/api/v1/employee/dashboard/getEmployeePaycode?'
        + 'startDate=' + startDate
        + '&endDate=' + endDate,
        options)
}

export const getAvailableShiftToCoverOffers = (options, startDate, endDate, cacheControl) => {

    return axios.get(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/requestToCover/getOffers?"
        + 'startDate=' + startDate
        + "&endDate=" + endDate
        + "&cacheControl=" + cacheControl,
        options)
}

export const getMyShifts = (options, startDate, endDate) => {
    return axios.get(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/dashboard/getEmployeeShift?startDate=" + startDate
        + "&endDate=" + endDate,
        options)
}

export const getMyShiftOffersToCover = (options, startDate, endDate) => {
    return axios.get(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/requestToCover/getMyOffers?startDate=${startDate}&endDate=${endDate}`, options)
}

export const getMyShiftRequestsToCover = (options, startDate, endDate) => {
    return axios.get(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/requestToCover/getMyRequests?startDate=" + startDate + "&endDate=" + endDate, options)
}

export const offerShiftToCover = (options, shifts, managerSetting, destinationEmployeeIds = [], timeOffRequestSubtypeId, timeOffRequestReasonId) => {
    const data = {
        shifts: shifts,
        hyperfindId: managerSetting.hyperfindId,
        managerSettingId: managerSetting.id,
        adminSettingId: managerSetting.adminSettingsId,
        idOfPrivateEmployees: destinationEmployeeIds,
        timeOffRequestReasonId: timeOffRequestReasonId,
        timeOffRequestSubtypeId: timeOffRequestSubtypeId,
    }

    return axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/requestToCover/submitOffer", data, options)
}

export const declineToCoverOffer = (options, offerId) => {
    let payload = {
        offerId
    }

    return axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/requestToCover/DeclineOffer", payload, options)
}

export const requestShiftToCover = (options, offerId, commentToManager, assignmentId = null) => {
    let payload = {
        offerId,
        commentToManager,
        assignmentId
    }

    return axios.put(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/requestToCover/submitRequest", payload, options)
}

export const retractMyToCoverOffer = (options, offerId) => {
    let payload = {
        offerId: offerId
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/requestToCover/RetractOfferRequested/", payload, options)
}

export const retractMyToCoverRequest = (options, offerId) => {
    let payload = {
        offerId: offerId
    }
    return axios.put(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/requestToCover/cancelRequest", payload, options)
}

/**
 *
 * @param {object} options Usual access tokens and username info
 * @param {Array} managerSettingGuid manager settings Guid
 * @param {object} shift A list of _shift_ that was clicked on
 * @param {string} searchString query string to search by employee name
 * @param {boolean} isPartial indicates if it is a partial shift being offered
 * @param {number?} partialStartDate start date of the partial shift being offered
 * @param {number?} partialEndDate end date of the partial shift being offered
 * @param {number} fetchSize page size
 * @param {number} offset number of entries to skip
 *
 * @return
 */
export function getEmployeesToOffer(options, managerSettingGuid, shifts, searchString, isPartial, partialStartDate = null, partialEndDate = null, isShowPJAndJtsEmployeesOnly, fetchSize, offset) {
    const data = {
        ManagerSettingId: managerSettingGuid,
        Shifts: shifts,
        SearchString: searchString,
        FetchSize: fetchSize,
        Offset: offset,
        IsPartial: isPartial,
        PartialStartDate: partialStartDate,
        PartialEndDate: partialEndDate,
        IsShowPjAndJtsEmployeesOnly: isShowPJAndJtsEmployeesOnly,
    }
    
    return axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/dashboard/GetAvailableEmployeesForPrivateOffering", data, options);
}

export function getMyShiftSwapOffers(options, startDate, endDate) {
    return axios.get(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/shiftSwap/getMySwapOffers?startDate=${startDate}&endDate=${endDate}`, options)
}

export function offerShiftToSwap(options, shifts, managerSetting, destinationEmployeeIds, preferredDates, partialStartDate = null, partialEndDate = null) {
    let payload = {
        shifts: shifts,
        hyperfindId: managerSetting.hyperfindId,
        managerSettingId: managerSetting.id,
        adminSettingId: managerSetting.adminSettingsId,
        idOfPrivateEmployees: destinationEmployeeIds,
        datePreferences: preferredDates,
        partialStartDate,
        partialEndDate,
    }

    return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/employee/shiftSwap/submitOffer', payload, options);
}

export function declineShiftSwapOffer(options, offerId) {
    let payload = {
        offerId
    }

    return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/employee/shiftSwap/declineOffer', payload, options);
}

/**
 *
 * @brief send PATCH to change shift to swap reporting status to OfferRetracted
 * @param {int} offerId the offerId to change
 */
export function handleRetractShiftToSwapOffer(options, offerId) {
    const data = {
        offerId: offerId
    }
    return axios.patch(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/shiftSwap/retractOffer", data, options)
}
/**
 * @brief Get Available Shift to Swap Offers for an employee in a period
 *
 * @param {string} startDate Start dates in ISO formats of periods to get available offers from
 * @param {string} endDate  End dates in ISO formats of periods to get available offers from
 * @param {Object} options this.state.options contains Authorization information
 */
export function getAvailableShiftToSwapOffers(options, startDate, endDate) {
    const data = {
        startDate: startDate,
        endDate: endDate,
        cacheControl: 1
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/shiftSwap/getAvailableOffers", data, options);
}

/**
 *
 * @param {Object} options this.state.options contains Authorization information
 * @param {Array<shift>} shiftsInfo Array of shift info to propose
 * @param {Date?} partialStartDate
 * @param {Date?} partialEndDate
 */
export function submitProposal(options, offerId, shiftsInfo, partialStartDate = null, partialEndDate = null) {
    const data = {
        offerId: offerId,
        shifts: shiftsInfo,
        partialStartDate,
        partialEndDate,
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/employee/shiftSwap/submitProposal', data, options);
}

/**
 *
 * @param {Object} options this.state.options contains Authorization information
 * @param {number} offerId
 * @param {number} proposalId
 * @param {string} commentToManager
 */
export function acceptOffer(options, offerId, proposalId, commentToManager) {
    const data = {
        offerId: offerId,
        proposalId: proposalId,
        commentToManager,
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/employee/shiftSwap/acceptOffer', data, options);
}

export function getPrivateOffers(options) {
    return axios.get(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/dashboard/getPrivateOffers`, options);
}

export function retrievePrivateOffers(offersToRetrieve, options) {
    const data = {
        OfferIds: offersToRetrieve
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/dashboard/retrievePrivateOffers`, data, options);
}

/**
 *
 * @param {Object} options
 * @param {number} proposalId
 * @param {number} offerId
 * @param {string} commentToManager
 */
export function acceptProposal(options, proposalId, offerId, commentToManager) {
    const data = {
        OfferId: offerId,
        ProposalId: proposalId,
        commentToManager
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/shiftSwap/acceptProposal`, data, options);
}

export function declineProposal(options, proposalId, offerId) {
    const data = {
        OfferId: offerId,
        ProposalId: proposalId
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/shiftSwap/declineProposal`, data, options);
}

export function getMySwapProposals(options, startDate, endDate) {
    return axios.get(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/shiftSwap/GetMySwapProposalsByDate?startDate=${startDate}&endDate=${endDate}`, options);
}

export function getMyGlobalHistory(options, startDate, endDate) {
    return axios.get(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/dashboard/GetMyGlobalHistory?startDate=${startDate}&endDate=${endDate}`, options);
}
export function Dismiss(options, offerId, proposalId = null, vtoId = null) {
    let payload = {
        offerId: offerId,
        proposalId: proposalId,
        voluntaryTimeOffId: vtoId
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/dashboard/Dismiss`, payload, options);
}
export function DismissAll(options) {
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/dashboard/DismissAll`, {}, options);
}
export function MarkAsViewed(options, offerId, proposalId = null, vtoId = null) {
    let payload = {
        offerId: offerId,
        proposalId: proposalId,
        voluntaryTimeOffId: vtoId
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/dashboard/MarkAsViewed`, payload, options);
}

export const retractShiftSwapProposal = (options, proposalId) => {
    let payload = {}
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/shiftswap/retractProposal/${proposalId}`, payload, options);
}

export const getMyShiftsToPropose = async (options, shiftSwapOfferId, isSkipValidation = false) => {
    return axios.get(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/shiftswap/getMyShiftsToPropose?shiftSwapId=${shiftSwapOfferId}&isSkipValidation=${isSkipValidation}`, options)
}

export const offerPartialToCover = (options, shift, managerSetting, partialStartDate, partialEndDate, destinationEmployeeIds, timeOffRequestSubtypeId, timeOffRequestReasonId) => {
    let payload = {
        shift: shift,
        hyperfindId: managerSetting.hyperfindId,
        managerSettingId: managerSetting.id,
        adminSettingId: managerSetting.adminSettingsId,
        partialStartDate,
        partialEndDate,
        idOfPrivateEmployees: destinationEmployeeIds,
        timeOffRequestSubtypeId: timeOffRequestSubtypeId,
        timeOffRequestReasonId: timeOffRequestReasonId,
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/requesttocover/PartialSubmitOffer`, payload, options)
}

// Open Shifts
export const getAvailableOpenShift = (options, startDate, endDate, managerSettingIds) => {
    let payload = {
        startDate,
        endDate,
        managerSettingIds,
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/openshift/getavailableopenshifts`, payload, options)
}

export const submitOpenShiftRequest = (options, openShifts, commentToManager) => {
    let payload = {
        openShiftsToRequest: openShifts,
        commentToManager,
    }

    return axios.post(`${process.env.REACT_APP_API_DOTNET}/api/v1/employee/openshift/submitrequest`, payload, options)
}

export const submitPartialOpenShiftRequest = (options, openShiftInfo) => {
    return axios.post(`${process.env.REACT_APP_API_DOTNET}/api/v1/employee/openshift/PartialSubmitOffer`, openShiftInfo, options)
}

export const getMyOpenShiftRequests = (options, startDate, endDate) => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}/api/v1/employee/openshift/getMyOpenShiftRequests?startDate=${startDate}&endDate=${endDate}`, options)
}

export const retractMyOpenShiftRequest = (options, requestId) => {
    let payload = {
        openShiftId: requestId
    }
    return axios.post(`${process.env.REACT_APP_API_DOTNET}/api/v1/employee/openshift/RetractRequest`, payload, options)
}

// Voluntary time off
export const getAvailableVTO = (options, startDate, endDate) => {
    let payload = {
        startDate,
        endDate,
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/voluntarytimeoff/getAvailableOffers`, payload, options)
}

/**
 *
 * @param {Object} options
 * @param {number} offerId
 * @param {string} commentToManager
 * @param {boolean} isPartial
 * @param {Date} partialStartDate
 * @param {Date} partialEndDate
 */
export const requestVTO = (options, offerId, commentToManager, isPartial = false, partialStartDate = null, partialEndDate = null) => {
    let payload = {
        offerId,
        commentToManager,
        isPartial,
        partialStartDate,
        partialEndDate,
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/voluntarytimeoff/submitRequest`, payload, options)
}

export const getMyVTORequest = (options, startDate, endDate) => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}/api/v1/employee/voluntarytimeoff/getMyRequests?startDate=${startDate}&endDate=${endDate}`, options)
}

export const retractVTORequest = (options, offerId) => {
    let payload = {
        voluntaryTimeOffId: offerId
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + `/api/v1/employee/voluntarytimeoff/retractRequest`, payload, options)

}

export const GetExtraDetails = (options, offerId, requestType) => {
    return axios.get(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/dashboard/GetExtraDetails?offerId=" + offerId
        + "&requestType=" + requestType,
        options)
}

/**
 *
 * @param {object} options Usual access tokens and username info
 * @param {Array} managerSettingGuid manager settings Guid
 * @param {object} shift A list of _shift_ that was clicked on
 */
export function getEligiblePrivateEmployeeSchedule(options, shifts, managerSettingGuid, managerSettingId, employeeId, partialStartDate = null, partialEndDate = null, isSkipValidation = false) {
    const data = {
        ShiftsToSwap: shifts,
        ManagerSettingAggregateRootId: managerSettingGuid,
        ManagerSettingId: managerSettingId,
        EmployeeId: employeeId,
        partialStartDate,
        partialEndDate,
        IsSkipValidation: isSkipValidation,
    }
    return axios.post(process.env.REACT_APP_API_DOTNET + "/api/v1/employee/shiftswap/GetEligiblePrivateEmployeeSchedule", data, options);
}

export function submitOfferWithProposal(options, shifts, managerSetting, PrivateEmployeeTo, shiftsToPropose,
    partialStartDate = null, partialEndDate = null, proposalPartialStartDate = null, proposalPartialEndDate = null) {
    let payload = {
        ShiftsToOffer: shifts,
        hyperfindId: managerSetting.hyperfindId,
        managerSettingId: managerSetting.id,
        adminSettingId: managerSetting.adminSettingsId,
        PrivateEmployeeTo: PrivateEmployeeTo,
        ShiftsToPropose: shiftsToPropose,
        OfferPartialStartDate: partialStartDate,
        OfferPartialEndDate: partialEndDate,
        ProposalPartialStartDate: proposalPartialStartDate,
        ProposalPartialEndDate: proposalPartialEndDate,
    };

    return axios.post(process.env.REACT_APP_API_DOTNET + '/api/v1/employee/shiftSwap/SubmitOfferWithProposal', payload, options);
}

export const getTimeOffRequestSubtypes = (options) => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}/api/v1/Common/GetTimeOffRequestSubtypes`, options)
}

export const getGlobalConfigs = (options) => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}/api/v1/employee/globalConfiguration/GetConfigs`, options)
}

export const getBuildInfos = (options) => {
    return axios.get(`${process.env.REACT_APP_API_DOTNET}/api/v1/Common/BuildInfos`, options);
}

/**
 * @param {BodyAllEmployeeOffersRequest} body
 * @returns {Promise<ApiEmployee.GetAllEmployeeOffersReportResponse>}
 */
export const getAllEmployeeOffersReport = (body) => {
    const url = `${process.env.REACT_APP_API_DOTNET}/api/v1/employee`;
    return axios.post(`${url}/AllEmployeeOffersReport/GetAllOffers`, body, currentHttpOptions());
}

/**
 * @param {BodyAllEmployeeOffersRequest} body 
 * @returns {Promise<ApiEmployee.GetAllEmployeeOfferValidationsReportResponse>}
 */
export const getAllEmployeeOfferValidations = (body) => {
    const url = `${process.env.REACT_APP_API_DOTNET}/api/v1/employee`;
    return axios.post(`${url}/AllEmployeeOffersReport/GetAllOffersWithValidation`, body, currentHttpOptions());
}
